// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FastForwardFilledSvg from "@fishx/icons-svg/es/asn/FastForwardFilled";
import FishxIcon from '../components/FishxIcon';

var FastForwardFilled = function FastForwardFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FastForwardFilledSvg
  }));
};

FastForwardFilled.displayName = 'FastForwardFilled';
export default React.forwardRef(FastForwardFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FastForwardFilled.js
// module id = 2667
// module chunks = 0